"use client";

import { ReviewHelpfulnessProps } from "@/app/ec/product/[basePath]/customer-reviews/customerReviews";
import Button from "@/components/design-system/button";
import { useModifyReviewHelpfulnessMutation } from "@/store/productApi";
import { useGetUserQuery } from "@/store/userApi";
import ThumbsDownIcon from "public/next-public/common/icons/thumbs-down-regular.svg";
import ThumbsUpIcon from "public/next-public/common/icons/thumbs-up-regular.svg";
import { FunctionComponent, useState } from "react";
import styles from "./reviewHelpfulness.module.scss";

const ReviewHelpfulness: FunctionComponent<ReviewHelpfulnessProps> = ({
  review: { reviewId, messageType, numberOfThumbsUp },
  pdpUrl,
}) => {
  const [reviewMessageType, setReviewMessageType] = useState<ReviewMessageType>(messageType);
  const { data: user, isLoading: userIsLoading } = useGetUserQuery();
  const [modifyReviewHelpfulness] = useModifyReviewHelpfulnessMutation();
  const thumbActionCallback = async (thumbUp: boolean) => {
    if (user && user.IsGuestUser && !userIsLoading) {
      setReviewMessageType(ReviewMessageType.LOGIN);
    } else {
      try {
        const result = await modifyReviewHelpfulness({
          reviewId,
          thumbUp,
        }).unwrap();
        switch (result) {
          case "SC_OK": {
            setReviewMessageType(ReviewMessageType.THANK_YOU);
            break;
          }
          case "SC_ERROR_OWN_REVIEW": {
            setReviewMessageType(ReviewMessageType.OWN_REVIEW);
            break;
          }
          case "SC_ERROR_THUMBS_UP_ALREADY_EXIST": {
            setReviewMessageType(ReviewMessageType.THUMBS_UP_ALREADY_EXIST);
            break;
          }
          default: {
            console.log("modify-review-helpfulness error occurred", result);
          }
        }
      } catch (error: any) {
        if (error.status === 401) {
          setReviewMessageType(ReviewMessageType.LOGIN);
        } else {
          console.log("modify-review-helpfulness error ocurried", error);
        }
      }
    }
  };
  return (
    <div className={styles.helpful}>
      <span className={styles.helpfulText}>
        {reviewMessageType ? (
          <>
            {reviewMessageType === ReviewMessageType.LOGIN && (
              <>
                Only registered customers may vote on reviews. Please <a href={`/login?origin=${pdpUrl}`}>login</a> to
                vote.
              </>
            )}
            {reviewMessageType === ReviewMessageType.OWN_REVIEW && <>You cannot vote on your own review.</>}
            {reviewMessageType === ReviewMessageType.THUMBS_UP_ALREADY_EXIST && (
              <>You have already voted on this review.</>
            )}
            {reviewMessageType === ReviewMessageType.THANK_YOU && <>Thank you for your feedback!</>}
          </>
        ) : (
          <>
            {numberOfThumbsUp > 0 && (
              <>
                {numberOfThumbsUp} {numberOfThumbsUp > 1 ? "people" : "person"} found this helpful.{" "}
              </>
            )}
            Was this review helpful to you?
          </>
        )}
      </span>
      {!reviewMessageType && (
        <div className={styles.helpfulButtons}>
          <Button
            variant="primary"
            color="gray"
            size="small"
            rounded
            showRightIcon={false}
            leftIcon={<ThumbsUpIcon width={16} height={16} aria-hidden="true" />}
            onClick={() => thumbActionCallback(true)}
            text="Yes"
          />
          <Button
            variant="primary"
            color="gray"
            size="small"
            rounded
            showRightIcon={false}
            leftIcon={<ThumbsDownIcon width={16} height={16} aria-hidden="true" />}
            onClick={() => thumbActionCallback(false)}
            text="No"
          />
        </div>
      )}
    </div>
  );
};

export default ReviewHelpfulness;
enum ReviewMessageType {
  LOGIN = "LOGIN",
  OWN_REVIEW = "OWN_REVIEW",
  THANK_YOU = "THANK_YOU",
  THUMBS_UP_ALREADY_EXIST = "THUMBS_UP_ALREADY_EXIST",
}
